import React from 'react';
import Anchor from '../components/dashboardNew/objects/Anchor'
import {Icon} from "in-touch-icons";


const NotificationBar = ( props ) => {

    const { noThanks, site_notification } = props;

    return (
        <div className="notification-bar active">
            <div className="col-12 col-md-9 col-lg-10 body-hole">
            <p className="heading-two notification-bar-name">{ site_notification.notification_name }</p>
                <p className="notification-bar-desc">{ site_notification.notification_content }</p>
            </div>
            <div className="col-12 col-md-3 col-lg-2 cta-hold">
                <Anchor path={ site_notification.path } anchorClass="link-cta" internal>
                    Complete task
                </Anchor>
            </div>
            <button type="button" className="notification-close"
                onClick={ () => noThanks( site_notification ) }>
                <Icon iconName={'close'} fill={'white'}/>
            </button>
        </div>
    );
};

export default NotificationBar;


// WEBPACK FOOTER //
// src/client/layouts/NotificationBar.js